import API_BASE_URL from "../../../../../Constants";

// Fetch all contacts that can be assigned to a management company.
export const fetchAllContacts = async () => {
  const response = await fetch(`${API_BASE_URL}/api/setup/contacts/get-all`, {
    credentials: "include",
  });
  if (!response.ok) {
    throw new Error("Failed to fetch contacts");
  }
  return await response.json();
};

// Fetch assigned contacts for a specific management company.
export const fetchAssignedContacts = async (managementId) => {
  const response = await fetch(
    `${API_BASE_URL}/api/setup/mgmtco-contact-intersections/management-company/${managementId}`,
    {
      method: "GET",
      credentials: "include",
      headers: { "Content-Type": "application/json" },
    }
  );
  if (!response.ok) {
    throw new Error("Failed to fetch assigned contacts");
  }
  return await response.json();
};

// Update a single contact.
export const updateContact = async (contactId, contactData) => {
  const response = await fetch(
    `${API_BASE_URL}/api/setup/contacts/${contactId}`,
    {
      method: "PUT",
      headers: {
        "Content-Type": "application/json",
      },
      credentials: "include",
      body: JSON.stringify(contactData),
    }
  );
  if (!response.ok) {
    const errorData = await response.json();
    throw new Error(errorData.message || "Failed to update contact");
  }
  return await response.json();
};

// Add a new contact.
export const addNewContact = async (contactData) => {
  const response = await fetch(`${API_BASE_URL}/api/setup/contacts`, {
    method: "POST",
    headers: {
      "Content-Type": "application/json",
    },
    credentials: "include",
    body: JSON.stringify(contactData),
  });
  if (!response.ok) {
    const errorData = await response.json();
    throw new Error(errorData.message || "Failed to add contact");
  }
  return await response.json();
};

// Update the list of assigned contacts for a management company.
export const updateAssignedContacts = async (managementId, contacts) => {
  const contactsDto = contacts.map((contact) => ({
    contactId: contact.contactID,
    managementCompanyId: managementId,
    mainContact: contact.mainContact || false,
    agentContact: contact.agentContact || false,
    collectionsContact: contact.collectionsContact || false,
  }));
  const response = await fetch(
    `${API_BASE_URL}/api/setup/mgmtco-contact-intersections/update/${managementId}`,
    {
      method: "PUT",
      headers: { "Content-Type": "application/json" },
      credentials: "include",
      body: JSON.stringify(contactsDto),
    }
  );
  if (!response.ok) {
    throw new Error("Failed to update assigned contacts");
  }
};
